import React from 'react';
import HealthCompleteness from '../health-completeness';

// The Emergencies view shows the workforce health/emergency profiles.
// The tab menu and the separate "Emergency Contacts" page were removed.
export default function Emergencies() {
  return <HealthCompleteness />;
}
